export const SET_SMART = 'SET_SMART';
export const SET_SHOWACTIVELINES = 'SET_SHOWACTIVELINES';
export const SET_CURRENTURL = 'SET_CURRENTURL';




